
export function removeInvalidZeros(input: number | string | undefined): string {
  if (!input) return ''
  const str = String(input).trim();

  // 如果是整数，直接返回
  if (!str.includes('.')) return str;

  // 去除末尾的 0
  let result = str.replace(/0+$/, '');

  // 如果小数点后没有数字了，去掉小数点
  if (result.endsWith('.')) {
    result = result.slice(0, -1);
  }

  return result;
}

export function base59Encode(input: string): string {
  try {
    //Base59 字符集
    const BASE59_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWYZabcdefghijklmnopqrstuvwyz123456789';
    // 将字符串转换为字节数组（Buffer 适用于 Node.js 环境）
    const bytes = Buffer.from(input, 'utf8');

    // 将字节数组转换为一个大整数
    let num = BigInt('0x' + bytes.toString('hex'));
    let result = '';

    // 将大整数转换为 Base59 表示
    while (num > 0) {
      const remainder = num % BigInt(59);
      result = BASE59_CHARSET[Number(remainder)] + result; // 映射到字符集
      num = num / BigInt(59); // 整数除法
    }

    return result || BASE59_CHARSET[0]; // 如果输入为空，返回第一个字符
  } catch(e) {
    console.log(e)
    return input
  }
}

export function generateGUID(): string {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // 降级方案：使用 Math.random()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
